import { type FC, type MouseEventHandler, useState } from 'react';
import { Button, Group } from '@mantine/core';
import { useCancelPayinOrder } from '~/entities/payin';
import { ConfirmationDialog } from '~/shared/ui/ConfirmationDialog';

export interface CancelProps {
    id: string;
    onCancel?: VoidFunction;
    onSuccess?: VoidFunction;
    onError?: (error: Error) => void;
}

export const Cancel: FC<CancelProps> = ({ id, onCancel, onSuccess, onError }) => {
    const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] = useState(false);

    const { mutate, isPending } = useCancelPayinOrder({
        onSuccess: () => {
            setIsDeleteConfirmationOpen(false);
            onSuccess?.();
        },
        onError,
    });

    const handleOpenDeleteConfirmation: MouseEventHandler<HTMLButtonElement> = (e) => {
        e.stopPropagation();
        setIsDeleteConfirmationOpen(true);
    };

    const handleSubmit = () => {
        mutate({
            orderId: {
                value: id,
            },
        });
    };

    const handleCloseDeleteConfirmation = () => {
        setIsDeleteConfirmationOpen(false);
    };

    const handleCancel: MouseEventHandler<HTMLButtonElement> = (e) => {
        e.stopPropagation();
        onCancel?.();
    };

    return (
        <>
            <Group justify='flex-end'>
                <Button
                    title='Удалить'
                    color='red'
                    disabled={isPending}
                    loading={isPending}
                    onClick={handleOpenDeleteConfirmation}
                >
                    Удалить
                </Button>

                {onCancel && (
                    <Button
                        title='Отмена'
                        disabled={isPending}
                        onClick={handleCancel}
                    >
                        Отмена
                    </Button>
                )}
            </Group>

            <ConfirmationDialog
                opened={isDeleteConfirmationOpen}
                title='Удаление ордера'
                message='Вы уверены, что хотите удалить ордер?'
                confirmText='Удалить'
                cancelText='Отмена'
                loading={isPending}
                onConfirm={handleSubmit}
                onCancel={handleCloseDeleteConfirmation}
            />
        </>
    );
};
